"use strict";import{Focusable as e}from"@spectrum-web-components/shared/src/focusable.js";import{CheckboxMixin as t}from"./CheckboxMixin.js";export class CheckboxBase extends t(e){get focusElement(){return this.inputElement}}
//# sourceMappingURL=CheckboxBase.js.map
